import { combineReducers } from 'redux'
import institution from './institution'
import fund from './fund'

export default combineReducers({
  institution,
  fund
})
